import { OptionsPillGroup } from "@/components/ui/buttons/OptionsPillGroup";
import { IonSkeletonText } from "@ionic/react";
import { useAllergenOptions } from "../../hooks/use-allergen-options";

interface AllergensGroupProps {
  selectedOptions: Set<string>;
  onToggleOption: (option: string) => void;
  disabled?: boolean;
  maximumDisplayNumber?: number;
}

export const AllergensGroup: React.FC<AllergensGroupProps> = ({
  selectedOptions,
  onToggleOption,
  disabled = false,
  maximumDisplayNumber,
}) => {
  const { options, isLoading } = useAllergenOptions();

  if (isLoading) {
    return (
      <div className="flex flex-col gap-4">
        <IonSkeletonText animated className="h-6 w-24 rounded" />
        <div className="grid grid-cols-2 gap-3">
          {Array.from({ length: maximumDisplayNumber ?? 8 }).map((_, i) => (
            <IonSkeletonText
              key={i}
              animated
              className="h-[42px] w-full rounded-full"
            />
          ))}
        </div>
      </div>
    );
  }

  return (
    <OptionsPillGroup
      label="Allergens"
      options={options}
      selectedOptions={selectedOptions}
      onToggleOption={onToggleOption}
      disabled={disabled}
      maximumDisplayNumber={maximumDisplayNumber}
    />
  );
};
